import React, {useEffect, useState} from 'react';
import {Button, Form, Input, Modal, Row, Col} from 'antd';
import {CommandDto} from '../../../api';
import {EditOutlined, ClockCircleOutlined} from "@ant-design/icons";
import DescriptionFormItem from "../../form/DescriptionFormItem";


const WaitCommandModal = ({onCommandCardData, initialData}: { onCommandCardData: Function; initialData?: CommandDto }) => {
    const [form] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState(false); // State für die Modal-Sichtbarkeit

    useEffect(() => {
        // Wenn initialData vorhanden ist, fülle das Formular mit den initialen Daten
        if (initialData) {
            form.setFieldsValue({
                waitInMs: initialData.waitInMs,
                description: initialData.description
            });
        }
    }, [initialData, form]);

    const onFinish = (values) => {
        let command: CommandDto = {waitInMs: values.waitInMs, commandType: 'WAIT', description: values.description};
        onCommandCardData(command);
        setIsModalVisible(false); // Modal schließen
    };

    const onReset = () => {
        form.resetFields();
    };

    // Funktion zum Öffnen des Modals
    const showModal = () => {
        setIsModalVisible(true);
    };

    // Funktion zum Schließen des Modals
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            {initialData == null &&
                <div style={{display: 'flex', alignItems: 'stretch', justifyContent: 'stretch'}}>
                  <Button
                      type="primary"
                      onClick={showModal}
                      style={{width: '100%', height: '100%'}}
                  >
                    <ClockCircleOutlined/> Warten
                  </Button>
                </div>}
            {initialData != null &&
                <Button
                    type="primary"
                    style={{float: 'right'}}
                    onClick={showModal}
                >
                  <EditOutlined/>
                </Button>
            }
            <Modal
                title="Warten"
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                    style={{maxWidth: 600}}
                    layout="vertical"
                >
                    <Form.Item name="waitInMs" label="Warten (ms)" rules={[{required: true, message: 'Bitte gebe eine Wartezeit ein'}]}>
                        <Input/>
                    </Form.Item>
                    <DescriptionFormItem />
                    <Form.Item>
                        <Row justify="center">
                            <Col style={{marginRight: 2.5}}>
                                <Button type="primary" htmlType="submit">
                                    {initialData ? "Speichern" : "Hinzufügen"}
                                </Button>
                            </Col>
                            <Col style={{marginLeft: 2.5}}>
                                <Button htmlType="button" onClick={onReset}>
                                    Zurücksetzen
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default WaitCommandModal;
